import AllResidents from './AllResidents.component';
export default AllResidents;
